import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPage.css';

function PrivacyPage() {
  return (
    <div className="privacy-page">
      <div className="privacy-hero">
        <div className="privacy-hero-content">
          <h1 className="privacy-hero-title">Privacy Policy</h1>
          <p className="privacy-hero-subtitle">
            Your privacy is important to us
          </p>
        </div>
      </div>

      <div className="privacy-content">
        <div className="privacy-section">
          <h2>Introduction</h2>
          <p>
            Digital Dream Safaris ("we", "our", or "us") is committed to protecting your privacy. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your 
            information when you visit our website or use our services.
          </p>
        </div>

        <div className="privacy-section">
          <h2>Information We Collect</h2>
          <p>We may collect information about you in a variety of ways:</p>
          <ul>
            <li><strong>Personal Information:</strong> Name, email address, phone number, and other contact details</li>
            <li><strong>Booking Information:</strong> Travel dates, preferences, and special requirements</li>
            <li><strong>Payment Information:</strong> Credit card details and billing information</li>
            <li><strong>Usage Data:</strong> Information about how you use our website</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Process and manage your bookings</li>
            <li>Communicate with you about your travel arrangements</li>
            <li>Send you marketing communications (with your consent)</li>
            <li>Improve our services and website</li>
            <li>Comply with legal obligations</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal 
            information against unauthorized access, alteration, disclosure, or destruction.
          </p>
        </div>

        <div className="privacy-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Object to processing of your information</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> info@digitaldreamsafaris.com<br />
            <strong>Phone:</strong> +255 757 433 105<br />
            <strong>Address:</strong> Arusha, Tanzania
          </p>
        </div>

        <div className="privacy-footer">
          <p>Last updated: {new Date().getFullYear()}</p>
          <Link to="/" className="btn btn-secondary">Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;

